import { useTranslation } from 'react-i18next';

import './style.scss';

interface ErrorStateProps {
  title?: string;
  message?: string;
  retryLabel?: string;
  onRetry?: () => void;
  className?: string;
}

export const ErrorState = ({ title, message, retryLabel, onRetry, className }: ErrorStateProps) => {
  const { t } = useTranslation();
  const resolvedTitle = title ?? t('common.label.error');
  const resolvedMessage = message ?? t('common.label.unableToLoad');
  const resolvedRetryLabel = retryLabel ?? t('common.label.retry');

  return (
    <section className={['dec-error-state', className].filter(Boolean).join(' ')} role="alert">
      <h2 className="dec-error-state__title">{resolvedTitle}</h2>
      <p className="dec-error-state__message">{resolvedMessage}</p>
      {onRetry && (
        <button className="btn btn-outline-primary" type="button" onClick={onRetry}>
          {resolvedRetryLabel}
        </button>
      )}
    </section>
  );
};
